import './cv-downloader.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import AWSService from '../../../services/AWSService';
import { useRef } from 'react';

const CVDownloaderComponent = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const linkRef = useRef<any>();
	const toast = useRef<any>();
	const DOWNLOAD_PARAM: string = 'CVDownloadUrl';
	const S3_BUCKET_DOMAIN: string = 'https://sharp-it-cvs.s3.eu-central-1.amazonaws.com/';
	const queryParams = new URLSearchParams(location.search);

	async function downloadCV(): Promise<void> {
		if (queryParams.has(DOWNLOAD_PARAM)) {
			const downloadUrl: string = queryParams.get(DOWNLOAD_PARAM)!;
			if (downloadUrl.startsWith(S3_BUCKET_DOMAIN)) {
				const fileKey: string | undefined = downloadUrl.split('/').pop();
				if (fileKey !== undefined) {
					const blob: Blob | undefined = await AWSService.downloadFile(fileKey, toast.current);
					if (blob !== undefined) {
						const downloadUrl: string = URL.createObjectURL(blob);
						linkRef.current.href = downloadUrl;
						// Set file name to be same as uploaded in AWS S3.
						linkRef.current.download = fileKey;
						linkRef.current.click();
					}
				}
			} else {
				navigate('/not-found');
			}
		} else {
			navigate('/not-found');
		}
	}

	return <>
		<div id="cv-download-btn-container" className='d-flex'>
			<Button 
				type='button'
				label="Download CV"
				size="small"
				id="cv-download-btn"
				iconPos="right"
				icon="pi pi-download"
				onClick={downloadCV}
				rounded
			/>
		</div>
		<Toast ref={toast} />
		<a ref={linkRef}></a>
	</>
}

export default CVDownloaderComponent
